import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import ConditionsSlideIn from "../../Components/ConditionsSlideIn";
import { Link } from "react-router-dom";
import useStopScroll from "../../CustomHooks/useStopScroll";
import VvPhoneNumber from "../../Components/VvPhoneNumber";

const Wrapper = styled.div`
  padding-top: ${(props) => (props.$useMobileMargins ? "16px" : "48px")};
  padding-bottom: ${(props) => (props.$useMobileMargins ? "28px" : "54px")};

  // just eye-balled what is a good page width.
  max-width: 680px;
  // max-width: 70ch;
`;

const LinkButton = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const LeadingSentence = styled.div`
  font-size: ${(props) => (props.$useMobileMargins ? "20px" : "22px")};
  font-weight: 500;
  padding-bottom: 20px;
`;

const SubTitle = styled.div`
  padding-top: 48px;
  font-size: 20px;
  font-weight: 500;
  padding-bottom: 20px;
`;

const Bold = styled.span`
  font-weight: 500;
`;

const About = () => {
  const [signInConditionsOpen, setSignInConditionsOpen] = useState(false);
  const screenWidth = useSelector((state) => state.screenWidth.value);

  // matches with home and petition. slightly smaller cutoff than results
  const useMobileMargins = screenWidth < 540;

  // will freeze but remember scroll position when slide in is open
  useStopScroll(signInConditionsOpen);

  return (
    <>
      {signInConditionsOpen && (
        <ConditionsSlideIn
          closeConditions={() => {
            setSignInConditionsOpen(false);
          }}
        />
      )}
      <Wrapper $useMobileMargins={useMobileMargins}>
        <LeadingSentence $useMobileMargins={useMobileMargins}>
          Verified Voice helps you use your political power to shape policy in
          our society.
        </LeadingSentence>
        {"Here's"} how it works:
        <SubTitle>1. Petitions</SubTitle>
        Petitions on Verified Voice are policy ideas that our government has the
        power to enact. Anyone can submit a petition to Verified Voice by
        emailing us.
        <br />
        <br />
        For each petition, we track where relevant legislators and candidates
        stand—whether they support it, oppose it, or {"haven't"} taken a clear
        position. You can see all legislator stances for a given petition on its
        petition page, or see a {"legislator's"} stances across all petitions on
        the{" "}
        <Bold>
          <Link to="/voter-guide" target="_blank" style={{ color: "black" }}>
            Voter Guide
          </Link>
        </Bold>
        . Because lawmakers are the ones who can actually turn these ideas into
        law, knowing where they stand helps you decide who to vote for to enact
        the policies you care about.
        <br />
        <br />
        Petition stances on the platform have currently been compiled by me,
        Rahul Patel, but they can also be compiled by petition authors or
        volunteers. Because this work is done manually, some stances may be
        missing. If {"you're"} curious about a specific {"legislator's"} stance
        and {"don't"} see it listed—or if {"you'd"} like to help compile stance
        information—please reach out to us.
        <SubTitle>2. Signing In</SubTitle>
        You are free, and encouraged, to browse petitions and use the Voter
        Guide without signing in. So why sign in? Signing in allows you to mark
        and store your petition stances. Your petition stances will also appear
        next to legislator stances in the Voter Guide, so you can see how your
        stances align with any legislator.
        <br />
        <br />
        Once you sign in, we may also ask you for basic demographic information,
        like your state and general location. This helps us understand which
        petitions are gaining support and from whom, and it helps when we
        present aggregated data to political offices or request petition stances
        from legislators. Legislators are more likely to take a stand on a
        petition that is popular with their constituents.
        <SubTitle>3. Voter Verification</SubTitle>
        Florida voters who meet{" "}
        <LinkButton
          onClick={() => {
            setSignInConditionsOpen(true);
          }}
        >
          these conditions
        </LinkButton>{" "}
        can link their account and all their petition stances to their voter
        registration. This is especially powerful in showing legislators true,
        verified constituent preference behind petitions. Each petition page
        displays the total support and opposition of verified Florida voters on
        Verified Voice.
        <br />
        <br />
        To verify your account, please contact us. We are working on expanding
        support for voter verification beyond Florida.
        {/* <SubTitle>Summary — Your Political Power with Verified Voice</SubTitle>
        To summarize, Verified Voice helps you realize your political power to enact policy in the following way:
        <ol><li></li></ol> */}
        <SubTitle>Policies</SubTitle>
        By using Verified Voice — including browsing our website, signing in,
        participating in petitions, submitting petitions, verifying your
        account, communicating with us, or interacting with our platform in any
        way — you agree to our{" "}
        <Bold>
          <Link
            to="/about/terms-of-service"
            target="_blank"
            style={{ color: "black" }}
          >
            Terms of Service
          </Link>
        </Bold>{" "}
        and{" "}
        <Bold>
          <Link
            to="/about/privacy-policy"
            target="_blank"
            style={{ color: "black" }}
          >
            Privacy Policy
          </Link>
        </Bold>
        .<SubTitle>Contact</SubTitle>
        We aim to strengthen our democracy by making political advocacy direct
        and convenient. Please contact <Bold>
          info@verifiedvoice.org
        </Bold> or{" "}
        <Bold>
          <VvPhoneNumber />
        </Bold>{" "}
        for any questions, comments, or concerns — including for technical help,
        petition submissions, or setting up election reminder notifications.
        <br />
        <br />
        Verified Voice is run by Rahul Patel in Mountain View, California.
      </Wrapper>
    </>
  );
};

export default About;
